<app-global-alert></app-global-alert>

<global-nav [multiSelect]="false" [contextList]="" [navUrl]="navUrl"></global-nav>
<mat-sidenav-container class="app-container x-sidebar">
    <mat-sidenav
        #sidenav
        fixedInViewport="true"
        fixedTopGap="60"
        (openedChange)="triggerResize()"
        [mode]="isLargeScreen() ? 'side' : 'over'"
        [opened]="sidenavOpen"
        class="sidenav-container"
    >
        <header class="sidenav-header">
            <div class="left-column">
                <h1 class="page-title" data-automation="listTitle">
                    {{ 'baseline.list.title' | translate }}
                </h1>
            </div>

            <div class="right-column">
                <button
                    mat-icon-button
                    color="accent"
                    aria-label="Menu"
                    class="toggle-sidenav"
                    data-automation="toggle-sidenav"
                    (click)="sidenav.toggle()"
                >
                    <mat-icon>double_arrow</mat-icon>
                </button>
            </div>
        </header>
        <div class="sidenav-component-container">
            <app-list></app-list>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <ng-container *ngIf="loading">
            <div class="page-loader-overlay">
                <div class="page-loader">
                    <mat-spinner diameter="60"></mat-spinner>
                    <h2>{{ 'baseline.loading' | translate }}...</h2>
                </div>
            </div>
        </ng-container>
        <button
            mat-icon-button
            color="accent"
            aria-label="Menu"
            class="toggle-sidenav mobile-btn"
            (click)="sidenav.toggle()"
        >
            <mat-icon>menu</mat-icon>
        </button>
        <div class="main-container">
            <router-outlet></router-outlet>
        </div>

        <ngx-global-contact-footer></ngx-global-contact-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
